// extracted by mini-css-extract-plugin
export default {"whyUs":"Services_whyUs__8VD1A","bookCustomization":"Services_bookCustomization__ZE4af","contactUs":"Services_contactUs__tZlPa","communityBanner":"Services_communityBanner__3NdDE"};